import javadoc from "refractor/javadoc";
export default javadoc;